// src/layout/builders/ProjectCompletionRequest/CompletionReqTable.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useProjectStatus from "../../../store/builders/useProjectStatus";
import ProjectTable from "../ProjectTable";

// Define allowed statuses for Completion Request projects (e.g., maybe allow 'hold'?)
// For now, keeping it disabled as requested.
const allowedStatusesForCompletionReq = [];

const CompletionRequestTable = () => {
  const navigate = useNavigate();
  const { projects, isLoading, fetchProjects, updateProjectStatus } =
    useProjectStatus();

  useEffect(() => {
    fetchProjects("completion_request");
  }, [fetchProjects]);

  const handleStatusChange = async (projectId, newStatus, comment = null) => {
    await updateProjectStatus(projectId, newStatus, comment);
    // ... (navigation logic remains the same) ...
    switch (newStatus) {
      case "active":
        navigate("/builder/projects?tab=live");
        break;
      case "hold":
        navigate("/builder/projects?tab=hold");
        break;
      case "completed":
        navigate("/builder/projects?tab=completed");
        break;
      case "approved":
        navigate("/builder/projects?tab=live");
        break;
      case "rejected":
        navigate("/builder/projects?tab=rejected");
        break;
      case "completion_request":
        fetchProjects("completion_request"); // Refresh current view
        // Or navigate('/builder/completionrequest');
        break;
      default:
        fetchProjects("completion_request"); // Default refresh
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <>
      <ProjectTable
        title="Completion Requests"
        projects={projects}
        handleStatusChange={handleStatusChange} // Handler might be redundant now
        navigate={navigate}
        allowedNextStatuses={allowedStatusesForCompletionReq} // (Currently [])
        showActionsColumn={false} // Add this prop
      />
    </>
  );
};

export default CompletionRequestTable;
